<template>
  <div class="relay-control">
    <div class="content flex-d-b-c">
      <!-- KPB板载电源 start -->
      <div class="power">
        <div class="top flex-b-c">
          <div class="name">KPB{{ $t("terminal.powerList") }}</div>
        </div>
        <div class="select-content" style="height: 50px">
          <div
            class="selects"
            v-for="(item, index) in kpbPower"
            :key="index"
            style="width: 318px"
          >
            <div class="name">{{ index + 1 }}.{{ $t(item.name) }}</div>
            <div style="width: 146px" class="flex-b-c">
              <div
                class="button"
                :class="{ active: kpbPower[index].value == 1 }"
                @click="kpbPowerOpen(index)"
              >
                {{ $t("terminal.open") }}
              </div>
              <div
                class="button"
                :class="{ active: kpbPower[index].value == 2 }"
                @click="kpbPowerClose(index)"
              >
                {{ $t("terminal.close") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- KPB板载电源 end -->

      <div class="power">
        <div class="top flex-b-c">
          <div class="name">{{ $t("terminal.powerList") }}</div>
          <div class="control">
            <el-button
              type="success"
              size="mini"
              round
              @click="powerAllOpen(1)"
              >{{ $t("terminal.allOpen") }}</el-button
            >
            <el-button
              type="danger"
              size="mini"
              round
              @click="powerAllOpen(2)"
              >{{ $t("terminal.allClose") }}</el-button
            >
          </div>
        </div>
        <div class="select-content">
          <div class="selects" v-for="(item, index) in power" :key="index">
            <div class="name">{{ index + 1 }}.{{ $t(item.name) }}</div>
            <div
              class="button"
              :class="{ active: power[index].value == 1 }"
              @click="powerOpen(index)"
            >
              {{ $t("terminal.open") }}
            </div>
            <div
              class="button"
              :class="{ active: power[index].value == 2 }"
              @click="powerClose(index)"
            >
              {{ $t("terminal.close") }}
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="top flex-b-c">
          <div class="name">{{ $t("terminal.mulCard") }}</div>
          <div class="control">
            <el-button type="success" size="mini" round @click="cardAllOpen">{{
              $t("terminal.allOpen")
            }}</el-button>
            <el-button type="danger" size="mini" round @click="cardAllClose">{{
              $t("terminal.allClose")
            }}</el-button>
          </div>
        </div>
        <div class="select-content cardselect">
          <div class="selects" v-for="(item, index) in card" :key="index">
            <div class="name">{{ index + 1 }}.{{ $t(item.name) }}</div>
            <div
              class="button"
              :class="{ active: card[index].value == 1 }"
              @click="cardOpen(index)"
            >
              {{ $t("terminal.open") }}
            </div>
            <div
              class="button"
              :class="{ active: card[index].value == 2 }"
              @click="cardClose(index)"
            >
              {{ $t("terminal.close") }}
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <el-button round @click="cancel">{{ $t("terminal.cancel") }}</el-button>
        <el-button round @click="confirm" type="primary">{{
          $t("terminal.confirm")
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RelayControl",
  data() {
    return {
      kpbPower: [{
        name: "terminal.firstChannel",   //0-没操作1-开2-关
        value: 0
      }],
      power: [{
        name: "terminal.firstChannel",   //0-没操作1-开2-关
        value: 0
      }, {
        name: "terminal.secondChannel",
        value: 0
      }, {
        name: "terminal.thirdChannel",
        value: 0
      }],
      card: [{
        name: 'terminal.firstChannel',
        value: 0
      },
      {
        name: 'terminal.secondChannel',
        value: 0
      },
      {
        name: 'terminal.thirdChannel',
        value: 0
      }, {
        name: 'terminal.fourthChannel',
        value: 0
      },
      {
        name: 'terminal.fifthChannel',
        value: 0
      }, {
        name: 'terminal.sixthChannel',
        value: 0
      }, {
        name: 'terminal.seventhChannel',
        value: 0
      }, {
        name: 'terminal.eighthChannel',
        value: 0
      },
      ]
    }
  },
  methods: {
    powerAllOpen(val) {
      this.power.forEach(ele => {
        ele.value = val;
      })
    },
    kpbPowerOpen(index) {
      this.kpbPower[index].value === 1 ? this.kpbPower[index].value = 0 : this.kpbPower[index].value = 1;
    },
    kpbPowerClose(index) {
      this.kpbPower[index].value === 2 ? this.kpbPower[index].value = 0 : this.kpbPower[index].value = 2;
    },
    powerOpen(index) {
      this.power[index].value === 1 ? this.power[index].value = 0 : this.power[index].value = 1;
    },
    powerClose(index) {
      this.power[index].value === 2 ? this.power[index].value = 0 : this.power[index].value = 2;
    },
    cardOpen(index) {
      this.card[index].value === 1 ? this.card[index].value = 0 : this.card[index].value = 1;
    },
    cardClose(index) {
      this.card[index].value === 2 ? this.card[index].value = 0 : this.card[index].value = 2;
    },
    cardAllOpen() {
      this.card.forEach((ele) => {
        ele.value = 1;
      })
    },
    cardAllClose() {
      this.card.forEach((ele) => {
        ele.value = 2;
      })
    },
    cancel() {
      this.$emit('control', false, this.power, this.card, this.kpbPower);
    },
    confirm() {
      let changeList = ''; //设置了哪些路的开或关
      let pow = this.power.reverse();
      let car = this.card.reverse();
      // let array = pow.concat(car);
			let array = [...this.kpbPower, ...pow, ...car];

      let status_list = '';
      array.forEach(ele => {
        changeList += (ele.value == 0 ? 0 : 1);
        if (ele.value == 1) {
          status_list += '1';
        } else if (ele.value == 2) {
          status_list += '0';
        } else if (ele.value == 0) {
          status_list += '0';
        }
      })
      // console.log('isOpen', changeList);
      // console.log('status', status_list);
      this.$emit('control', true, changeList, status_list);
    }
  }
}
</script>

<style lang="scss" scoped>
.relay-control {
  width: 100%;
  height: 100%;

  .content {
    width: 100%;
    height: 100%;

    .power {
      width: 100%;

      .top {
        width: 100%;

        .name {
          width: 180px;
          font-size: 16px;
        }

        .control {
          width: 200px;
        }
      }

      .select-content {
        width: 90%;
        margin: 10px auto;
        font-size: 16px;
        display: flex;
        flex-direction: column;
        height: 100px;
        flex-wrap: wrap;
        .name {
          width: 150px;
          text-align: left;
        }
        .selects {
          text-align: center;
          height: 50px;
          line-height: 50px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-left: 10px;
          .button {
            width: 60px;
            height: 30px;
            line-height: 30px;
            border: 1px solid #dcdfe6;
            color: #606266;
            border-radius: 10px;
            cursor: pointer;
          }
          .active {
            color: #fff;
            background-color: #409eff;
            border-color: #409eff;
          }
        }
      }
    }
  }
  .card {
    width: 100%;

    .top {
      width: 100%;

      .name {
        width: 160px;
        font-size: 16px;
      }

      .control {
        width: 200px;
      }
    }

    .select-content {
      width: 90%;
      margin: 10px auto;
      font-size: 16px;
      display: flex;
      flex-direction: column;
      height: 100px;
      flex-wrap: wrap;
      .name {
        width: 150px;
        text-align: left;
      }
      .selects {
        height: 50px;
        text-align: center;
        line-height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 10px;
        .button {
          width: 60px;
          height: 30px;
          line-height: 30px;
          border: 1px solid #dcdfe6;
          color: #606266;
          border-radius: 10px;
          cursor: pointer;
        }
        .active {
          color: #fff;
          background-color: #409eff;
          border-color: #409eff;
        }
      }
    }
    .cardselect {
      height: 200px;
    }
  }
}
</style>
